<template>
  <LessonAccessesPage lessonAccessAccountType="BASIC_CLASS"/>
</template>
<script>
import LessonAccessesPage from "@/components/pages/LessonAccessesPage.vue";

export default {
  components: {LessonAccessesPage},
}
</script>